import React, { useEffect, useContext, useState } from "react";
import HomeContainer from "../../components/layout/Container/Home-Container";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { motion, useAnimation, AnimatePresence } from "framer-motion";
import "./Home.css";
import "./Home-sass.scss";
import LoaderContext from "../../components/LoaderContext";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { Email } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  subTitle: {
    marginBottom: "16px",
    fontSize: "75px",
    [theme.breakpoints.down("md")]: {
      fontSize: "54px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "29px",
    },
  },
  fontStyleP: {
    color: "#2C394B",
    marginBottom: "10px",
    fontSize: "20px",
    fontFamily: "Cairo, Roboto, 'Helvetica Neue', sans-serif",
    [theme.breakpoints.down("md")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "23px",
    },
  },
  fontStyleText: {
    // color: '#2C394B',
    // marginBottom: "10px",
    fontSize: "18px",
    fontFamily: "Cairo, Roboto, 'Helvetica Neue', sans-serif",
    [theme.breakpoints.down("md")]: {
      fontSize: "17px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "23px",
    },
  },
  fontStyle: {
    color: "#2C394B",
    // marginBottom: "10px",
    fontSize: "52px",
    fontFamily: "Cairo, Roboto, 'Helvetica Neue', sans-serif",
    [theme.breakpoints.down("md")]: {
      fontSize: "38px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "23px",
    },
  },
  title: {
    // marginBottom: "16px",
    fontSize: "50px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "35px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "25px",
    },
  },
}));
const Home = () => {
  const classes = useStyles();
  const { isLoading } = useContext(LoaderContext);
  const controls = useAnimation();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isLoading) {
      controls.start((i) => ({
        y: 0,
        opacity: 1,
        transition: { delay: i * 0.1 + 1.2 },
      }));
    } else {
      controls.start({ opacity: 0, y: 5 });
    }
  }, [isLoading, controls]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {/* 
            Hi there, I'M <br /> HUMAIL SALEEM */}

      <HomeContainer id="home">
        <div className="text-alignment">
          <motion.div
            custom={0}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.5, duration: 1 }}
            whileHover={{ scale: 1.05 }}
          >
            <Typography
              component={motion.div}
              animate={controls}
              custom={0}
              variant="h5"
              style={{ marginBottom: "0px", color: "#ffb510" }}
              className="interactive-text"
            >
              Hi there
              <motion.div
                style={{ display: "inline-block" }}
                animate={{ rotate: [50, 90, 50] }}
                transition={{
                  repeat: Infinity,
                  duration: 1.4,
                  repeatDelay: 0.7,
                }}
                whileHover={{ scale: 1.2, rotate: 360 }}
                whileTap={{ scale: 0.8 }}
              >
                👋
              </motion.div>
              , I'm
            </Typography>
          </motion.div>
          <motion.div animate={controls} custom={2}></motion.div>

          <motion.div
            custom={1}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2, duration: 1 }}
            whileHover={{ scale: 1.02 }}
          >
            <Typography
              textAlign="center"
              component={motion.div}
              animate={controls}
              custom={2}
              variant="h2"
              className={classes.subTitle}
            >
              <div className="box">
                <div className="title">
                  <span className="block"></span>
                  <motion.h1
                    className={`${classes.subTitle} gradient-text`}
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    HUMAIL SALEEM<span></span>
                  </motion.h1>
                </div>

                <div className="role">
                  <div className="block"></div>
                  <motion.p
                    className={`p-class ${classes.fontStyleP}`}
                    whileHover={{ scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 300 }}
                  >
                    Full Stack DEVELOPER
                  </motion.p>
                </div>
              </div>
            </Typography>
          </motion.div>
          <motion.div
            custom={2}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2.5, duration: 1 }}
            whileHover={{ scale: 1.02 }}
          >
            <Typography
              component={motion.div}
              animate={controls}
              custom={4}
              variant="body1"
              className={`${classes.fontStyle} interactive-text enhanced-text`}
            >
              I am a passionate Mid-level Full Stack Web Developer
            </Typography>
          </motion.div>
          <motion.div
            custom={3}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 3, duration: 1 }}
            whileHover={{ scale: 1.02 }}
          >
            <Typography
              component={motion.div}
              animate={controls}
              custom={4}
              variant="body1"
              style={{ marginBottom: "30px" }}
              className={`${classes.fontStyleText} interactive-text enhanced-text`}
            >
              Specializing in building modern, responsive web applications with
              cutting-edge technologies. I excel at creating seamless user
              experiences and robust backend systems that scale efficiently.
            </Typography>
          </motion.div>

          <motion.div
            custom={4}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 3.5, duration: 1 }}
            whileHover={{ scale: 1.02 }}
          >
            <Typography
              component={motion.div}
              animate={controls}
              custom={4}
              variant="body1"
              style={{ marginBottom: "30px" }}
              className={`${classes.fontStyleText} interactive-text enhanced-text`}
            >
              <strong>Expertise:</strong> MERN Stack Development • Full Stack
              Development • Freelance Consulting • Open Source Contributor •
              Continuous Learning Enthusiast
            </Typography>
          </motion.div>

          <motion.div animate={controls} custom={5}>
            <motion.div
              custom={5}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 4, duration: 1 }}
            >
              <Link to="/contactMe">
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Button
                    variant="outlined"
                    offset={0}
                    duration={500}
                    to="contact"
                    color="primary"
                    size="large"
                    className="glow-on-hover"
                    startIcon={
                      <Email sx={{ fontSize: 20, color: "#ffb510" }} />
                    }
                  >
                    CONTACT ME ?
                  </Button>
                </motion.div>
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </HomeContainer>
    </>
  );
};

export default Home;
